(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    get noteInputEl() {
      return this.querySelector("textarea");
    }

    get currentValue() {
      return this.noteInputEl.value;
    }

    constructor() {
      super();

      this.lastValue = this.currentValue;

      this.noteInputEl.addEventListener(
        "keyup",
        debounce((event) => {
          event.target.dispatchEvent(new Event("change"));
        }, 750)
      );

      this.noteInputEl.addEventListener(
        "change",
        debounce((event) => {
          if (this.currentValue === this.lastValue) return;

          this.classList.add(
            "updatable--is-updating",
            "reflects-update-state--state-is-updating"
          );

          const body = JSON.stringify({ note: event.target.value });

          fetch(`${window.theme.routes.cart_update_url}`, {
            ...{
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            },
            ...{ body },
          })
            .then((response) => response.text())
            .then((state) => {
              this.lastValue = JSON.parse(state).note;
              this.classList.remove(
                "updatable--is-updating",
                "reflects-update-state--state-is-updating"
              );
            });
        }, 300)
      );
    }
  }

  customElements.define("cart-note", CartNote);

  (function() {
    window.addEventListener('DOMContentLoaded', function() {
      var agreementCheckbox = document.querySelector('[data-agreement-checkbox]');
      var checkoutButton = document.querySelector('[data-checkout-button]');

      if (agreementCheckbox && checkoutButton) {
        var updateSubmitButtonState = function() {
          if (agreementCheckbox.checked) {
            checkoutButton.removeAttribute('disabled');
          } else {
            checkoutButton.setAttribute('disabled', true);
          }
        };

        updateSubmitButtonState();

        agreementCheckbox.addEventListener('change', updateSubmitButtonState);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
